// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/toast/index.css
// module id = 455
// module chunks = 32